/**
 * The procedures tab is shared by every encounter type, so its unsaved-changes key is a single
 * constant rather than a per-encounter section.
 */
export const ENCOUNTER_PROCEDURES_TAB_SECTION = "encounter-procedures-tab";

export enum GynecologicalEncounterSections {
  Encounter = "gynecological-encounter",
  VitalsSign = "gynecological-vitals-sign",
}

export enum NewbornIPPEncounterSections {
  Encounter = "newborn-ipp-encounter",
  BirthDetails = "newborn-ipp-birth-details",
  Size = "newborn-ipp-size",
  VitalsSign = "newborn-ipp-vitals-sign",
  Feeding = "newborn-ipp-feeding",
  MedicationsTherapies = "newborn-ipp-medications-therapies",
  GestationalAge = "newborn-ipp-gestational-age",
}

export enum TransferOfCareEncounterSections {
  Encounter = "transfer-of-care-encounter",
  ClientInformation = "transfer-of-care-client-information",
  TransferProvider = "transfer-of-care-transfer-provider",
  ReceivingProvider = "transfer-of-care-receiving-provider",
  TransferDetails = "transfer-of-care-transfer-details",
}

export enum NewbornPostpartumEncounterSections {
  Encounter = "newborn-postpartum-encounter",
  StateOfNewborn = "newborn-postpartum-state-of-newborn",
  Size = "newborn-postpartum-size",
  VitalsSign = "newborn-postpartum-vitals-sign",
  MedicationsTherapies = "newborn-postpartum-medications-therapies",
  InputsOutputs = "newborn-postpartum-inputs-outputs",
}

export enum PrimaryCareEncounterSections {
  Encounter = "primary-care-encounter",
}

export enum PrenatalEncounterSections {
  Encounter = "prenatal-encounter",
}

export enum PostpartumEncounterSections {
  Encounter = "postpartum-encounter",
  Feeding = "postpartum-feeding",
  Lochia = "postpartum-lochia",
  Output = "postpartum-output",
  ActivityNutrition = "postpartum-activity-nutrition",
  Sleep = "postpartum-sleep",
  SocialHealth = "postpartum-social-health",
  EmotionalHealth = "postpartum-emotional-health",
  SexualActivity = "postpartum-sexual-activity",
  MedicationsTherapies = "postpartum-medications-therapies",
  Vitals = "postpartum-vitals",
}

export enum EncounterLaborSections {
  Encounter = "encounter-labor",
}

/**
 * The billing tab's biller section, which stages its own diagnoses and procedures until Save Billing
 * Info writes them. Its own key, because it is saved by a different button than the encounter's.
 */
export const ENCOUNTER_BILLING_TAB_SECTION = "encounter-billing-tab";
